module.exports = __webpack_public_path__ + "static/media/Hacksaw.067bb850.jpeg";